import React, { Component } from 'react';
import { clientsData } from '@/utils/constants';
import "./our-clients.scss"

export default class OurClients extends Component {
    render() {

        return (
            <div className="our-clients-section">
                <h3>Our Clients Include</h3>
                <div className="our-clients">
                    {clientsData?.map((client, ind) => {
                        return (
                            <div className="client" key={ind}>
                                <img src={client?.src} alt={`client-${ind + 1}`}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        )
    }
}
